<template>
  <div
    class="cover flex-col"
    @click="menuList = null"
    style="position: relative"
  >
    <div class="content-box">
      <div
        class="select-content flex-grow"
        :style="{ height: '82vh', overflowY: 'hidden' }"
      >
        <!-- 结果头部 -->
<!--        <div class="head-condition justify-between">
          <div>
            <div class="restext" v-if="searchResult.bookList[0].bookJuanList[0].bookPageList.length > 0">
              找到
              <span>{{ searchResult.bookList[0].bookJuanList[0].bookPageList.length }}</span>
              条搜索结果
            </div>
          </div>
        </div>-->

          <div
            class="heitani"
            :style="{ height: '72vh', overflowY: 'scroll' }"
          >
            <!-- Collapse 折叠面板 -->
            <div>
              <div
                v-for="(item, index) in searchResult.bookList"
                :key="index"

              >
                <div>
                  <span
                    class="head-title justify-between cursorauto"
                  >
                    <div>
                       <span>
                        <i @click="
                          viewDetail(
                            { juanNum: '' },
                            item.id,
                            '',
                            item.bookName,
                            item.isLock
                          )
                        " v-show="item.isLock" class="el-icon-lock" style="opacity: 1;font-size: 15px;margin-right: 0"></i>
                         <!--                        <i v-show="!item.isLock" class="el-icon-unlock" style="opacity: 1;font-size: 15px;margin-right: 0"></i>-->
                      </span>
                      <span
                        class="cursorpointer"
                        @click="
                          viewDetail(
                            { juanNum: '' },
                            item.id,
                            '',
                            item.bookName,
                            item.isLock
                          )
                        "
                      >{{ item.bookName }}</span
                      >
                      <!-- @click.stop="gotoBookDetail(item)" -->
                      <!-- <span class="book-number">（越南之部一册）</span> -->
                      <span class="sm-title">{{ searchResult.total }}条</span>
                      <div class="search-content-box" @click.stop="">
                        <div class="search-info-box flex">
                          <span class="search-info align-center">
                            {{ item.categoryName }}
                          </span>
                          <span class="search-info align-center">
                            <!-- <img src="/static/icon/user.png" class="icon" /> -->
                            {{ item.writer }}
                            <!--                            <ul v-for="(w, key, i) in item.writerarr" :key="i">-->
                            <!--                              <li v-if="i != 0">，</li>-->
                            <!--                              <li v-for="(ww, ii) in w" :key="ii">-->
                            <!--                                <i v-if="ii != 0">、</i>-->
                            <!--                                [{{ ww.writerDynastyName }}]<i-->
                            <!--                                  @click="-->
                            <!--                                    linkdialog(-->
                            <!--                                      item.writerList,-->
                            <!--                                      item.copierList,-->
                            <!--                                      ww.writerName,-->
                            <!--                                      item.bookName-->
                            <!--                                    )-->
                            <!--                                  "-->
                            <!--                                  class="cursor"-->
                            <!--                                  >{{ ww.writerName }}</i-->
                            <!--                                >-->
                            <!--                                &lt;!&ndash; <i v-if="ii + 1 == w.length">{{ key }}</i> &ndash;&gt;-->
                            <!--                              </li>-->
                            <!--                            </ul>-->
                          </span>
                          <span
                            class="search-info align-center"
                            v-if="item.copierList"
                          >
                            <!-- <img src="/static/icon/auth.png" class="icon" /> -->
                            <!-- {{ item.copier }}校點 -->
                            <span v-for="(c, ci) in item.copierList" :key="ci"
                            ><i v-if="ci != 0">、</i
                            ><i class="cursor"
                            >{{ c.copierName }}</i
                            ></span
                            >校
                          </span>
                          <!-- <span class="search-info align-center">
                            <img
                              v-if="item.dcUrl"
                              src="/static/icon/temp.png"
                              class="icon"
                            />
                            <img
                              v-else
                              src="/static/icon/temp1.png"
                              :style="{ width: '1.35rem', height: '1.35rem' }"
                              class="icon"
                            />

                            底本參考
                          </span> -->
                          <span class="search-info align-center">
                            {{ item.publishTime }}
                          </span>
                        </div>
                      </div>
                    </div>
<!--                    <span>{{ activeName && activeName[item.bookName] }}</span>-->
<!--                    <div>
                      &lt;!&ndash; 该icon透明度为0，模拟原来的按钮不能传参 ,同事slot不更新数据，所以原箭头禁止鼠标事件，只负责展示 &ndash;&gt;
                      <span class="booksss" @click.stop="gotoBookDetail(item)"
                      ><i class="el-icon-s-order flagImg"></i>书籍介绍</span
                      >
                      <span
                        class="booksss"
                        @click.stop="addReadListBox(item.id)"
                      ><i class="el-icon-notebook-2 flagImg"></i>添加到书单</span
                      >
                    </div>-->
                  </span>
                </div>
                <div style="display: flex;font-family: PingFangSC, PingFang SC;">
                  <div class="search-content-box">
                    <!-- <el-collapse
                    v-model="activeListName[item.id]"

                    accordion
                  > -->
                    <div
                      v-for="(list, idx) in item.bookJuanList"
                      :key="`${idx}${list.juanName}`"
                      :name="list.juanName"
                    >
                      <div>
                        <div
                          class="search-content flex list"
                          :key="page.id + page.text"
                          v-for="(page, index1) in getPageItems(list.bookPageList,pageCurrent)"
                        >
                          <el-card shadow="hover" style="width: 100%;white-space: normal; word-wrap: break-word; overflow-wrap: break-word; margin-bottom: 5px">
                            <span class="sort">
                              {{ index1 + 1 }}.&nbsp;

                              <i
                                class="el-icon-warning-outline"
                                v-if="page.hitType == 2"
                              />
                            </span>
                            <span
                              class="content cursorpointer"
                              @click="
                            viewDetail(
                              page,
                              page.bookId,
                              page.id,
                              item.bookName,
                              item.isLock
                            )
                          "
                              v-html="extractFirstSpanWithContext(page.text)"
                            ></span>
                          </el-card>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <el-pagination
              style="margin: 20px auto; text-align: center"
              background
              layout="prev, pager, next"
              :total="searchResult.total"
              :current-page="pageCurrent"
              @current-change="changePage"
            >
            </el-pagination>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WordTest",
  components: {
    //PaginationNew
    // Analysis,
    // EchartGx,
  },
  data () {
    return {
      // sortType:0,//排序类型 1 朝代 2拼音 修改搜索方式 0拼音 1朝代 2数量
      searchResult: {
        bookList: [],
        total: 0
      },
      pageCurrent:1,
      newParam:{

      },
      advancedQuery:[],
      neardQuery:[],
      searchFilter:[],
    }
  },
  created () {
    //this.searchResult.bookList=[...this.$store.state.itemList]
    this.searchResult.bookList=[JSON.parse(localStorage.getItem('itemList'))]
    console.log(this.searchResult.bookList)
    this.searchResult.total=JSON.parse(localStorage.getItem('itemList')).bookJuanList[0].bookPageList.length
    //this.searchResult.total=this.$store.state.itemList.hitNum
    //this.newParam=this.$store.state.newParam
    this.newParam=JSON.parse(localStorage.getItem('newParam'))
    //this.advancedQuery=this.$store.state.advancedQuery
    this.advancedQuery=JSON.parse(localStorage.getItem('advancedQuery'))
    //this.neardQuery=this.$store.state.neardQuery
    this.neardQuery=JSON.parse(localStorage.getItem('neardQuery'))
    //this.searchFilter=this.$store.state.searchFilter
    this.searchFilter=JSON.parse(localStorage.getItem('searchFilter'))
  },
  computed: {

  },
  methods: {
    changePage(val){
      this.pageCurrent=val
    },
    getPageItems(array, x) {
      // 参数验证
      if (!Array.isArray(array) || array.length === 0) {
        return [];
      }

      if (typeof x !== 'number' || x < 1) {
        return [];
      }

      // 计算起始索引和结束索引
      const startIndex = 10 * (x - 1);
      const endIndex = 10 * x;

      // 处理边界情况
      if (startIndex >= array.length) {
        return [];
      }
      // 返回指定范围的数组元素
      return array.slice(startIndex, Math.min(endIndex, array.length));
    },
    /*extractFirstSpanWithContext (htmlString, contextLength = 28) {
      // 1. 创建临时DOM容器
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;

      // 2. 查找第一个span元素
      const firstSpan = tempDiv.querySelector('span');
      if (!firstSpan) return null;

      // 3. 收集所有连续的span元素
      const spans = [firstSpan];
      let nextNode = firstSpan.nextSibling;

      while (nextNode) {
        if (nextNode.nodeType === Node.ELEMENT_NODE && nextNode.tagName === 'SPAN') {
          spans.push(nextNode);
          nextNode = nextNode.nextSibling;
        } else {
          break;
        }
      }

      // 4. 获取所有span的HTML（保留所有样式）
      const spansHTML = spans.map(span => span.outerHTML).join('');
      const spansText = spans.map(span => span.textContent).join('');

      // 5. 获取完整文本用于定位
      const fullText = tempDiv.textContent;
      const spansStart = fullText.indexOf(spansText);
      if (spansStart === -1) return null;

      // 6. 提取span前的文本（精确8个字符）
      let beforeText = '';
      let beforeChars = 0;
      let node = spans[0].previousSibling;

      // 收集前面的所有文本节点（从近到远）
      const prevTextNodes = [];
      while (node) {
        if (node.nodeType === Node.TEXT_NODE) {
          prevTextNodes.unshift(node); // 反向插入保持顺序
        }
        node = node.previousSibling;
      }

      // 从前往后取字符（保持原始顺序）
      for (const textNode of prevTextNodes) {
        if (beforeChars >= contextLength) break;
        const text = textNode.textContent;
        const needed = contextLength - beforeChars;
        beforeText = text.slice(-needed) + beforeText;
        beforeChars += Math.min(needed, text.length);
      }

      // 7. 提取span后的文本（精确8个字符）
      let afterText = '';
      let afterChars = 0;
      node = spans[spans.length - 1].nextSibling;

      while (node && afterChars < contextLength) {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          const needed = contextLength - afterChars;
          afterText += text.slice(0, needed);
          afterChars += Math.min(needed, text.length);
        }
        node = node.nextSibling;
      }

      // 8. 构建结果字符串
      let result = '';

      // 添加前导省略号（检查前面是否还有内容）
      if (this.hasContentBefore(spans[0], beforeChars, contextLength)) {
        result += '...';
      }

      // 添加前导文本
      result += beforeText;

      // 添加所有连续的span标签（完整保留所有内容样式）
      result += spansHTML;

      // 添加后续文本
      result += afterText;

      // 添加后置省略号（检查后面是否还有内容）
      if (this.hasContentAfter(spans[spans.length - 1], afterChars, contextLength)) {
        result += '...';
      }

      return result;
    },
    hasContentBefore(node, collectedChars, requiredChars) {
      if (collectedChars < requiredChars) return false;
      let prevNode = node.previousSibling;
      while (prevNode) {
        if (prevNode.nodeType === Node.TEXT_NODE && prevNode.textContent.trim()) {
          return true;
        }
        prevNode = prevNode.previousSibling;
      }
      return false;
    },
    hasContentAfter(node, collectedChars, requiredChars) {
      if (collectedChars < requiredChars) return false;
      let nextNode = node.nextSibling;
      while (nextNode) {
        if (nextNode.nodeType === Node.TEXT_NODE && nextNode.textContent.trim()) {
          return true;
        }
        nextNode = nextNode.nextSibling;
      }
      return false;
    },*/
    extractFirstSpanWithContext(htmlString, contextLength = 28) {
      try {
        // 1. 创建临时DOM容器
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;

        // 2. 查找第一个span元素
        const firstSpan = tempDiv.querySelector('span');
        if (!firstSpan) {
          // 如果没有span标签，返回前56个字符
          const fullText = tempDiv.textContent || tempDiv.innerText || '';
          return fullText.length > 56 ? fullText.substring(0, 56) + '...' : fullText;
        }

        // 3. 收集所有连续的span元素
        const spans = [firstSpan];
        let nextNode = firstSpan.nextSibling;

        while (nextNode) {
          if (nextNode.nodeType === Node.ELEMENT_NODE && nextNode.tagName === 'SPAN') {
            spans.push(nextNode);
            nextNode = nextNode.nextSibling;
          } else {
            break;
          }
        }

        // 4. 获取所有连续span的HTML和文本
        const spansHTML = spans.map(span => span.outerHTML).join('');
        const spansText = spans.map(span => span.textContent).join('');

        // 5. 获取完整文本用于定位
        const fullText = tempDiv.textContent || tempDiv.innerText || '';
        const spansStart = fullText.indexOf(spansText);
        if (spansStart === -1) return spansHTML;

        // 6. 提取span前的文本
        let beforeHTML = '';
        let beforeChars = 0;
        let node = spans[0].previousSibling;

        // 收集前面的所有节点（从近到远）
        const prevNodes = [];
        while (node) {
          prevNodes.unshift(node); // 反向插入保持顺序
          node = node.previousSibling;
        }

        // 从前往后处理节点（保持原始顺序）
        for (const prevNode of prevNodes) {
          if (beforeChars >= contextLength) break;

          if (prevNode.nodeType === Node.TEXT_NODE) {
            const text = prevNode.textContent;
            const needed = contextLength - beforeChars;
            beforeHTML = text.slice(-needed) + beforeHTML;
            beforeChars += Math.min(needed, text.length);
          } else if (prevNode.nodeType === Node.ELEMENT_NODE) {
            // 处理元素节点（保留标签和样式）
            const nodeText = prevNode.textContent || '';
            const needed = contextLength - beforeChars;

            if (nodeText.length <= needed) {
              // 整个元素节点都可以加入
              beforeHTML = prevNode.outerHTML + beforeHTML;
              beforeChars += nodeText.length;
            } else {
              // 元素节点文本过长，需要截取
              // 这里简化处理，只取文本内容
              beforeHTML = nodeText.slice(-needed) + beforeHTML;
              beforeChars += needed;
              break;
            }
          }
        }

        // 7. 提取span后的文本（保留span标签）
        let afterHTML = '';
        let afterChars = 0;
        node = spans[spans.length - 1].nextSibling;

        while (node && afterChars < contextLength) {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            const needed = contextLength - afterChars;
            afterHTML += text.slice(0, needed);
            afterChars += Math.min(needed, text.length);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            // 处理元素节点（保留标签和样式）
            if (node.tagName === 'SPAN') {
              // 如果是span标签，完整保留
              afterHTML += node.outerHTML;
              afterChars += (node.textContent || '').length;
            } else {
              // 其他元素节点，递归处理其内容
              const nodeText = node.textContent || '';
              const needed = contextLength - afterChars;

              if (nodeText.length <= needed) {
                // 整个元素节点都可以加入
                afterHTML += node.outerHTML;
                afterChars += nodeText.length;
              } else {
                // 元素节点文本过长，需要截取其内容
                // 这里简化处理，只取文本内容
                afterHTML += nodeText.slice(0, needed);
                afterChars += needed;
                break;
              }
            }
          }

          // 移动到下一个节点
          node = afterChars < contextLength ? node.nextSibling : null;
        }

        // 8. 构建结果字符串
        let result = '';

        // 添加前导省略号（检查前面是否还有内容）
        if (this.hasContentBefore(spans[0], beforeChars, contextLength)) {
          result += '...';
        }

        // 添加前导文本
        result += beforeHTML;

        // 添加所有连续的span标签（完整保留所有内容样式）
        result += spansHTML;

        // 添加后续文本
        result += afterHTML;

        // 添加后置省略号（检查后面是否还有内容）
        if (this.hasContentAfter(spans[spans.length - 1], afterChars, contextLength)) {
          result += '...';
        }

        return result;
      } catch (error) {
        console.error('Error in extractFirstSpanWithContext:', error);
        // 出错时返回原始HTML的前56个字符
        const textOnly = htmlString.replace(/<[^>]*>/g, '');
        return textOnly.length > 56 ? textOnly.substring(0, 56) + '...' : textOnly;
      }
    },

    hasContentBefore(node, collectedChars, requiredChars) {
      if (collectedChars < requiredChars) return false;
      let prevNode = node.previousSibling;
      while (prevNode) {
        if (prevNode.nodeType === Node.TEXT_NODE && prevNode.textContent.trim()) {
          return true;
        } else if (prevNode.nodeType === Node.ELEMENT_NODE) {
          // 检查元素节点是否有内容
          const text = prevNode.textContent || '';
          if (text.trim()) return true;
        }
        prevNode = prevNode.previousSibling;
      }
      return false;
    },

    hasContentAfter(node, collectedChars, requiredChars) {
      if (collectedChars < requiredChars) return false;
      let nextNode = node.nextSibling;
      while (nextNode) {
        if (nextNode.nodeType === Node.TEXT_NODE && nextNode.textContent.trim()) {
          return true;
        } else if (nextNode.nodeType === Node.ELEMENT_NODE) {
          // 检查元素节点是否有内容
          const text = nextNode.textContent || '';
          if (text.trim()) return true;
        }
        nextNode = nextNode.nextSibling;
      }
      return false;
    },
    viewDetail (item, bookId, pageId, bookName,isLock=false) {
      if(isLock){
        this.$message({
          message: '您所在的机构尚未订阅此资源。请联系您的机构管理员。',
          type: 'warning'
        });
        return
      }
      let search = JSON.stringify({ textType: this.newParam.textType, searchType: this.newParam.searchType, keyword: this.newParam.keyword, advancedQuery: this.advancedQuery, nearQuery: this.neardQuery, searchFilter: this.searchFilter })
      // let search = JSON.stringify(this.newParam)
      // 搜索条件结束
      const query = {
        bookId,
        bookName,
        pageId,
        search,
        from:'sousuo'
        //juanNum: item.juanNum,
        //keywords: this.newParam.keyword
      }

      let routeData = this.$router.resolve({
        path: "/read",
        query,
      })
      // 在Vue组件中
      // let routeData = this.$router.push({ name: 'Read', params: { operStr: str } })

      window.open(routeData.href, "_blank")
    },
    gotoBookDetail (item) {
      const url = this.$router.resolve("/bookDetail?id=" + item.id)
      window.open(url.href)
    },
    gotoRead (item) {

      const url = this.$router.resolve("/read?bookId=" + item.id + '&bookName=' + item.bookName+'&from=sousuo')
      window.open(url.href)
    },
  },
  beforeDestroy () {

  }
};
</script>

<style lang="less" scoped>
@primary-color: #f4f0e8;
@first-color: #2c7e8d;
@secont-color: #666666;
@three-color: #999999;
@four-color: #333333;
@PingFang-SC-Medium: PingFang-SC-Medium;
@PingFangSC-Regular: PingFangSC-Regular;
@PingFang-SC-Bold: PingFang-SC-Bold;
@PingFang-SC-ExtraLight: PingFang-SC-ExtraLight;
/deep/.el-tree {
  background: none;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #E9B63E;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: white;
}
// /deep/.el-pagination.is-background .btn-next,
// /deep/.el-pagination.is-background .btn-prev,
// /deep/.el-pagination.is-background .el-pager li {
//   color: @first-color;
// }
/deep/.el-pagination.is-background .btn-next:hover,
/deep/.el-pagination.is-background .btn-prev:hover,
/deep/.el-pagination.is-background .el-pager li:hover {
  background: #E9B63E;
}
/deep/.el-button--primary {
  background: #DBB054;
  border-color: #fff;
}
/deep/.el-card__body{
  padding: 10px;
}
// /deep/.el-checkbox__input .is-checked .el-checkbox__inner,
// /deep/.el-checkbox__input .is-indeterminate .el-checkbox__inner {
//   background: #2c7e8d;
//   border-color: #2c7e8d;
// }

.zuozhe {
  /deep/.el-checkbox__label {
    max-width: 109px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
}
.restext {
  font-family: @PingFang-SC-ExtraLight;
  font-size: 12px;
  color: @secont-color;
  letter-spacing: 0;
  line-height: 12px;
  font-weight: 400;
  span {
    font-family: @PingFang-SC-Bold;
    font-weight: 700;
  }
}
.booksss {
  display: inline-block;
  font-family: PingFang-SC-Medium;
  font-size: 14px;
  color: #573E0D;
  letter-spacing: 0;
  line-height: 14px;
  font-weight: 400;
  margin-left: 20px;
  cursor: pointer;
}
/deep/.el-input-group__append {
  // transform: scaleX(-1) scaleY(-1);
  background: @first-color;
  border-radius: 0px 4px 4px 0px;
}
.mengban {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
}
@import url(../assets/iconfont.css);
/deep/.el-card {
  //background: rgba(255, 255, 255, 0.8);
  //border-radius: 4px;
  border: none;
  border-bottom: 1px solid #EDE7D8 ;
}
/deep/.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  background-color: #FEFBF4;
}
/deep/.el-input-number.is-controls-right .el-input__inner {
  padding-left: 10px;
}
/deep/.el-autocomplete {
  width: 100%;
}
.checkboxstyle {
  margin-left: 20px;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #E9B63E;
}
/deep/ .el-checkbox__label{
  color: #2B2B2B;
}
.xinghao {
  // color: #3366cc;
  color: #e60012;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #E9B63E;
  border-color: #E9B63E;
}
/deep/.el-input .is-active .el-input__inner,
/deep/.el-input__inner:focus {
  border-color: #E9B63E;
}
/deep/.el-checkbox__input .is-focus .el-checkbox__inner,
/deep/.el-checkbox__inner:hover {
  border-color: #E9B63E;
}
/deep/ .el-dialog {
  width: 80%;
}
/deep/.el-dialog__body {
  padding: 0 20px 30px;
}

.heitani {
  transition: height 0.3s linear;
  // will-change: height;
  height: 100%;
}
.margin-ri {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 1.15rem;
  margin-top: 0.5rem;
}
.sback {
  width: 100%;
  height: 88px;
  background: url("/static/homenew/sback.png") no-repeat;
  background-size: 100% 88px;
}
.topbottom {
  width: 100%;
  height: 1.5rem;
  text-align: center;
  // line-height: 2rem;
  // position:absolute;
  // opacity: 0;
  position: relative;
  img {
    position: absolute;
    cursor: pointer;
    height: 1rem;
    //  animation:mymove 2s infinite;
  }
  .totop {
    animation: mymove 2s infinite;
  }
  .tobottom {
    animation: mymovetwo 2s infinite;
  }
}
@keyframes mymove {
  from {
    bottom: 0px;
    opacity: 100;
  }
  to {
    bottom: 5px;
    opacity: 0;
  }
}
@keyframes mymovetwo {
  from {
    top: 0px;
    opacity: 0;
  }
  to {
    top: 5px;
    opacity: 100;
  }
}

// /deep/ .el-input-group__prepend{
//   padding-left:10px;
//   padding-right: 0px;
// }
// /deep/ .el-input__inner{
//   padding: 0 20px;
// }
// /deep/ .el-input{
//   width: 90%;
// }
// /deep/.icon-menu{
//   // color:#1b1b1b
//   cursor: pointer;
// }

.submit-btn {
  width: 80px;
  height: 39px;
  // margin-left: 2rem;
  font-size: 1rem;
  padding: 8px 20px 8px 20px;
  color: #fff;
  // background-color: #3366cc;
  // border-color: #3366cc;
  // transform: scaleX(-1) scaleY(-1);
  background: #795636;
  border-radius: 0px 4px 4px 0px;
  border: none;
}
.submit-btn :hover,
.submit-btn :focus {
  background: var(--el-button-hover-color);
  border-color: var(--el-button-hover-color);
  color: var(--el-button-font-color);
}
.searchA {
  background: var(--el-button-hover-color);
  border-color: var(--el-button-hover-color);
  font-size: 1rem;
  padding: 8px 16px 6px 16px;
}
.cover {
  display: flex;
  // background: #f4f0e8;
  background: url("/static/homenew/sback.png") no-repeat;
  background-size: 100% 80%;
  .btn {
    padding: 0.3rem 0.9rem;
    background: #e6e6e6;
    border-radius: 1rem;
    font-size: 0.8421rem;
    text-align: center;
    cursor: pointer;
    color: #fff;
    // margin-right: 1.15rem;
    background: #795636;
    border: 1px solid rgba(44, 126, 141, 0.4);
    border-radius: 4px 0px 0px 4px;

    font-family: @PingFang-SC-Bold;
    font-size: 14px;
    color: #fff;
    letter-spacing: 0;
    text-align: center;
    line-height: 14px;
    font-weight: 700;

    &:not(disabled=disabled):hover {
      background: #3366cc;
      color: #fff;
    }
    &.active {
      background: #3366cc;
      color: #fff;
    }
    &[disabled="disabled"] {
      cursor: not-allowed;
    }

    img {
      width: 0.94rem;
    }
  }
  .margin {
    margin: 0.65rem 0;
  }
  .marginNew {
    margin: 1.2rem 0 0.65rem;
  }
  .search-box {
    // padding: 2rem 0 1rem;
    // box-shadow: 0rem 0rem 1rem 0rem rgba(112, 112, 112, 0.2);
    // background: #f0f8ff;
    // height: 80px;
    // line-height: 80px;
    padding-top: 20px;
    > .content {
      width: 86rem;
      margin: 0 auto;
      min-width: 1000px;
      max-width: 100%;
    }
    .left-input-box {
      width: 556px;
      /deep/ .el-input-group__prepend {
        width: 80px;
      }
      // /deep/ .input-select {
      // display: block;
      // margin-bottom: 1rem;
      // > .el-input__inner {
      //   width: 27rem;
      // }
      // &:first-child .el-input__inner{
      //   width: 31.2rem;
      // }

      // &.input-select-label {
      //   .el-input__inner {
      //     // width: 23.5rem;
      //     text-align: center;
      //   }
      // }
      // }

      .after {
        width: 1.15rem;
        height: 1.15rem;
        cursor: pointer;
      }
    }

    .search-range {
      width: 36rem;
      // height: 7.74rem;
      height: 1.04rem;
      margin-top: 8px;
      // background: #ffffff;
      // border: 0.1rem solid #c9c9c9;
      // border-radius: 0.4rem;
      // padding: 0.52rem 0.78rem;
      color: #3366cc;
      font-size: 16px;
      cursor: pointer;
      /deep/ .el-tree {
        height: 20rem;
        overflow-y: auto;
      }
      /deep/ .el-dialog {
        width: 680px;
      }
      .zdbox {
        display: flex;
        flex-direction: column;
      }
      .zdxuanze {
        display: flex;
        margin-top: 8px;
        margin-left: 24px;
      }
      .weixuanze {
        font-size: 12px;
        color: #3366cc;
        margin-top: 8px;
        padding-left: 24px;
        i {
          font-style: normal;
          color: #606266;
        }
      }
      .zidingyi {
        display: block;
        width: 150px;
      }
      // .xdwenxianborder {
      //   border: 1px solid #eee;
      //   border-radius: 3px;
      //
      //   margin-top: 0px;
      //   padding: 8px;

      // }
      .kuohao {
        font-size: 30px;
      }
      .xdwenxian {
        display: block;
        width: 30rem;
        margin: 0 5px;
        // height: 2rem;
        // padding: 5px;

        // width: 100%;
        // display: flex;
        font-size: 12px;
        line-height: 16px;

        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .select-range {
        padding: 1.77rem 3.75rem;

        /deep/ .el-checkbox__label {
          color: #3366cc;
        }
        i {
          cursor: pointer;
        }
      }

      /deep/ .el-tree-node {
        font-size: 14px;
      }
      /deep/ .el-tree-node .el-tree-node .el-tree-node {
        white-space: pre-wrap;
      }
      /deep/ .el-tree-node .el-tree-node .el-tree-node .el-tree-node__content {
        // font-size: .8947rem;
        height: auto;
        line-height: 26px;
        span:nth-child(3) {
          display: inline-block;
          box-sizing: border-box;
          padding-right: 42px;
          width: 100%;
          // flex:1
          // line-height: 20px;
        }
      }
    }
  }
  .borderline {
    height: 100%;
    width: 100%;
    // border-bottom: 0.1rem solid #ccc;
    // border-top:0.1rem solid #ccc;
    .borderlinecon {
      width: 80%;
      // height: 10px;
      margin: 0 auto;
      // border-top: 1px solid #ccc;
    }
    // .topline{

    // }
    // .bottomline{
    //   border-bottom:1px solid #ccc;
    // }
  }

  .content-box {
    // display: flex;
    display: -webkit-box;
    flex: 1;
    flex-grow: 1;
    overflow: auto;
    padding: 0 10px;
    //width: 80%;
    margin: 30px 100px 0 100px;
    // margin-top: 1rem;
    .open-all-btn {
      // margin-left: 24px;
      width: 86px;
      height: 27px;
      line-height: 27px;
      cursor: pointer;
      // background: @first-color;
      // border: 1px solid rgba(44, 126, 141, 0.4);
      // border-radius: 4px 0px 0px 4px;
      // transform: scaleX(-1) scaleY(-1);
      background: #fff;
      border: 1px solid #795636;
      border-radius: 0px 4px 4px 0px;
      span {
        height: 24px;
        line-height: 20px;
      }
      font-family: @PingFangSC-Regular;
      font-size: 12px;
      color: #795636;
      letter-spacing: 0;
      text-align: center;
      //line-height: 12px;
      font-weight: 400;
    }
    .tree-list {
      // padding: 24px;
      margin-right: 16px;
      /*padding-left: 15px;
      padding-right: 10px;*/
      padding: 24px;
      width: 300px;
      // width: 16.7%;
      position: relative;
      // padding-bottom: 50px;
      // background: #fff;
      background: #FEFBF4;
      border-radius: 4px;
      // overflow: auto;
      // overflow-y: scroll;
      overflow: hidden;
      .el-input {
        width: 180px;
      }
      .drag-box {
        left: initial;
        right: 0;
      }
      .simplestyle {
        // width: 290px;
        margin: 10px auto 5px;
      }
      .treescroll {
        height: 100%;
        // overflow-y: hidden;
        // overflow-x: hidden;
        padding-right: 5px;
        padding-bottom: 50px;
        // .simplestyle {
        //   width: 290px;
        //   margin-top: 10px;
        // }
        .tree {
          height: 33%;
          .treeitem {
            height: 70%;
            overflow-y: auto;
            overflow-x: hidden;
          }
        }
      }
      img {
        width: 1.56rem;
      }
      .tree {
        margin: 0;
        font-size: 18px;
        color: #1b1b1b;
        padding: 12px 0;
        border-bottom: 0.1rem solid #ccc;
        .padding-left {
          padding-left: 1.6rem;
        }
        .left-width {
          width: 290px;
        }
        .titles {
          display: flex;
          margin-bottom: 15px;
          text-align: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #573E0D;
        }
        .right-icon {
          font-size: 1.2rem;
          color: #9999;
          cursor: pointer;
        }
      }
      .treeTittle{
        display: flex;
        justify-content: space-between;
        .tittleName{
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 24px;
          color: #573E0D;
        }
      }
    }
    .select-content {
      flex: 3;
      // background: #f5f9ff;
      padding: 1.4rem;
      background: #fff;
      border-radius: 4px;

      .head-condition {
        padding: 0 1.4rem 1rem;
        .label {
          font-size: 1.04rem;
          // font-family: FZShuSong-Z01T;
          // font-weight: bold;
          color: #1b1b1b;
        }
      }
      .head-title {
        // color: #3366cc;
        // font-size: 1.2632rem;
        flex: 1;
        flex-grow: 1;

        font-family: @PingFang-SC-Medium;
        font-size: 16px;
        color: #002f38;
        letter-spacing: 0;
        line-height: 16px;
        font-weight: 500;

        // 原来列表的箭头不能控制传参 使用该icon模拟
        i {
          margin-top: 1rem;
          font-size: 13px;
          margin-right: 8px;
          opacity: 0;
        }
        .flagImg{
          opacity: 1;
          font-size: 20px;
          margin-right: 5px;
        }
      }
      .book-number {
        color: #3366cc;
        font-size: 1.15rem;

        padding-right: 0.36rem;
      }
      .sm-title {
        // color: #3366cc;
        // font-size: 0.73rem;
        font-family: @PingFang-SC-Medium;
        font-size: 12px;
        color: #573E0D;
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 500;
      }
      .juan-title {
        font-size: 0.94rem;

        font-weight: bold;
        color: #3366cc;
        font-family: @PingFang-SC-Medium;
        font-size: 12px;
        color: @first-color;
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 500;
        // margin-top:.94rem;
        i {
          cursor: pointer;
        }
        .num {
          font-size: 0.73rem;
          padding-left: 0.63rem;
        }
      }

      .search-content-box {
        width: 98%;
        color: #313131;
        font-size: 0.94rem;
        // box-sizing: border-box;
        margin-bottom: 0.8rem;
        line-height: 2;

        > .search-info-box {
          // border-bottom: 0.1rem solid #999;
          // padding-bottom: 0.42rem;
          // margin-bottom: 0.42rem;
        }
        .search-info {
          padding-right: 1.88rem;
          // font-size: 0.83rem;
          font-family: @PingFangSC-Regular;
          font-size: 12px;
          color: @three-color;

          letter-spacing: 0;
          line-height: 3;
          font-weight: 400;

          .icon {
            width: 1.15rem;
            margin-right: 0.3rem;
            // cursor: pointer;
          }
          ul {
            display: flex;
          }
          i {
            font-style: normal;
            opacity: 1;
            margin: 0;
            font-size: 12px;
          }
        }
        .content {
          flex: 1;
          flex-grow: 1;
          // font-size: 0.94rem;

          // color: #313131;
          // line-height: 2.3rem;
          overflow: hidden;
          // white-space: nowrap;
          text-overflow: ellipsis;
          font-family: @PingFang-SC-ExtraLight;
          font-size: 14px;
          color: @four-color;
          letter-spacing: 0;
          // line-height: 18px;
          font-weight: 400;
          margin-top: 8px;

          &.in-title {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .book-icon {
          width: 1.15rem;
          height: 1.15rem;
          margin-left: 1rem;
          cursor: pointer;
        }
        .search-content {
          // margin-top: 0.52rem;
          width: 100%;
          &.list {
            // cursor: pointer;
          }
          .sort {
            font-family: @PingFang-SC-ExtraLight;
            font-size: 14px;

            // color: #e60012;
            color: @four-color;
            // padding-right: 1rem;
            margin-top: 8px;
          }
        }
      }
    }
  }

  .search-icon {
    font-size: 18px;
    display: flex;
    height: 100%;
    align-items: center;
    cursor: pointer;
  }
}
.fixed-btn {
  position: absolute;
  left: 0;
  bottom: 0;
}
.span-ellipsis {
  width: 100%;
  font-size: 14px;
  //overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.second-btn-box {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  padding: 10px 24px;
  // background: #fff;
  // border-top: 0.1rem solid #ccc;
  position: absolute;
  bottom: 0;
  left: 0;
  background: var(--el-button-hover-color);
  border-color: var(--el-button-hover-color);
}
/deep/ .el-collapse-item__header {
  height: auto;
  align-items: flex-start;
  position: relative;
  line-height: 2rem;
  border-bottom: none;

  .el-collapse-item__arrow {
    display: none;
    margin-top: 1rem;
    position: absolute;
    right: 0;
    pointer-events: none;
  }
}
/deep/ .el-collapse {
  // border-bottom-color: #ccc;
  border-top: none;
}

/deep/ .el-collapse-item__wrap {
  border-bottom: none;
}
/deep/ .el-collapse-item {
  border-bottom: 1px solid #ccc;
  position: relative;
}
/deep/ .el-collapse-item__content {
  padding-bottom: 5px;
  line-height: 1.8rem;
}
/deep/ .cursorauto {
  cursor: auto;
}
/deep/ .cursorpointer {
  cursor: pointer;
  color: #573E0D;
}
</style>



// WEBPACK FOOTER //
// src/view/searchItem.vue